// extracted by mini-css-extract-plugin
module.exports = {"terms":"EmailForm_terms__HIJsT","hidden":"EmailForm_hidden__jn9ZF","inputRow":"EmailForm_inputRow__sLMr2"};